import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Container } from 'components/layout/Container'
import times from 'lodash/times'
import AddIcon from 'transfix-icons/build/AddIcon'
import { Box, Typography, Skeleton } from 'transfix-ui/core'
import { useQueryParams, StringParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useBookableShipmentSavedSearchContext } from 'apps/fleet-planner/context'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import useTruckAvailability from 'apps/fleet-planner/hooks/useTruckAvailability'
import { Button, Fab, IconButton, TopNav } from 'transfix-ui'
import { BookableShipmentSavedSearchAvailableTrucksRow } from '../alert/BookableShipmentSavedSearchAvailableTrucksRow'
import { BookableShipmentSavedSearchShareTruckContextCard } from '../alert/BookableShipmentSavedSearchShareTruckContextCard'

export const TruckAvailabiltyPage = () => {
  const { trackEvent } = useFMSAnalytics()
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsShareAvailableTrucksEnabled } = getFlag('fmsShareAvailableTrucks')
  const history = useHistory()
  const { search } = useLocation()
  const { isMobile } = useBreakpointContext()
  const { setTrackConversion } = useTrackConversionContext()
  const [{ eventSource }] = useQueryParams({
    eventSource: StringParam,
  })
  const {
    savedSearches = [],
    isSavedSearchesLoading,
    openTruckAvailabilityModal,
  } = useBookableShipmentSavedSearchContext()
  const { availableTruckDays = [], addBaseDaysChangeHandler } = useTruckAvailability({
    savedSearches,
    initialTotalBaseDays: 7,
  })

  const addSevenDaysClickHandler = () => {
    addBaseDaysChangeHandler(7)
  }
  const openTruckAvailabilityModalHandler = () => {
    trackEvent('Truck Availability', 'CLICKED_POST_TRUCK_CTA_IN_TRUCK_AVAILABILITY_PAGE')
    openTruckAvailabilityModal()
  }
  const rowBeforeClickHandler = () => {
    setTrackConversion('web', 'lane_alert_carrier_truck_availability')
  }

  // Clear UTM params
  useEffect(() => {
    if (eventSource === 'savedSearchEmail') {
      // Remove event query param from url.
      history.push('/truck-availability')
    }
  }, [eventSource, history])

  // Opens the truck availability modal when the posting query parameter is present
  useEffect(() => {
    if (search.includes('?posting=true')) {
      openTruckAvailabilityModal()
    }
  }, [search, openTruckAvailabilityModal])

  return (
    <Box>
      <TopNav title='Truck Availability' showBackButton showMenu={false}>
        <Box display='flex'>
          {isFmsShareAvailableTrucksEnabled && (
            <Box pr={1}>
              <BookableShipmentSavedSearchShareTruckContextCard />
            </Box>
          )}
          <Box>
            {!isMobile ? (
              <IconButton
                color='primary'
                label='Post a truck'
                Icon={AddIcon}
                onClick={openTruckAvailabilityModalHandler}
                size='large'
              />
            ) : (
              <Fab
                aria-label='Post a truck'
                onClick={openTruckAvailabilityModalHandler}
                color='primary'
                size='large'>
                <AddIcon />
              </Fab>
            )}
          </Box>
        </Box>
      </TopNav>
      <Container hidePadding>
        <Box data-test='dispatcher-saved-searches-container' pt={2} px={2}>
          <Box p={1}>
            <Typography variant='subtitle1'>
              With the truck availability planner, enter your available trucks then sit back and let
              Transfix search for loads in areas your trucks will be empty. We’ll notify you when we
              find matching loads!
            </Typography>
          </Box>
          {isSavedSearchesLoading &&
            times(5).map(item => (
              <Box p={1} key={item}>
                <Box pt={2}>
                  <Skeleton variant='rectangular' height='50px' width='100%' />
                </Box>
              </Box>
            ))}
          {!isSavedSearchesLoading &&
            availableTruckDays.length > 0 &&
            availableTruckDays.map(availableTruckDay => {
              const { filteredSearches, pickupStartDate } = availableTruckDay || {}
              return (
                <Box pt={2} pb={2} key={pickupStartDate}>
                  <BookableShipmentSavedSearchAvailableTrucksRow
                    onClick={rowBeforeClickHandler}
                    isSharedSavedSearch={false}
                    pickupStartDate={pickupStartDate}
                    filteredSearches={filteredSearches}
                  />
                </Box>
              )
            })}
          <Box pt={2} display='flex' justifyContent='center'>
            <Button color='tertiary' onClick={addSevenDaysClickHandler}>
              Show 7 More Days
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}
